import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const root = css`
  block-size: ${spacing(7)}; // 56px
  padding-inline-start: ${spacing(1)};
`
export const icon = css`
  padding-inline-end: ${spacing(1)}; // 8px
`
export const completed = css`
  opacity: 0.6;
`
export const paper = css`
  max-inline-size: 550px;
  inline-size: 100%;
`
